// Vendor
import { Component, Input, OnInit } from '@angular/core';

// Interfaces
import { ComplianceReport } from 'FoldersApp/apps/compliance-report-history-app/interfaces/compliance-report-data.interface';

// Services
import { UrlsService } from 'Angular/services/core/urls.service';

@Component({
    standalone: false,
    selector: 'tr[ycn-notifications-menu-report-history-item]',
    templateUrl: './notifications-menu-report-history-item.template.html',
})
export class NotificationsMenuReportHistoryItemComponent implements OnInit {
    @Input() report!: ComplianceReport;

    reportDate: string = '';

    displayTitle: string = '';

    downloadUrl: string = '';

    constructor(private urlsService: UrlsService) {}

    ngOnInit(): void {
        this.displayTitle = this.report.title?.trim() || 'Untitled Report';
        this.downloadUrl = this.urlsService.getUrl(this.urlsService.COMPLIANCE.DOWNLOAD_REPORT, {
            complianceReportId: this.report.id,
        });
        this.reportDate = new Date(this.report.create_date).toLocaleString('default', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        });
    }
}
